var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"id":"maintenance-splash"}},[_c('div',{staticClass:"container container-extra-small"},[_c('div',{staticClass:"has-text-centered"},[_c('Logo')],1),_c('p',{staticClass:"has-text-centered has-margin-vertical"},[_vm._v(" We'll be back shortly. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }